import React from "react";

function EngineeringTypeStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="col-lg-12">
          <div className="pt-3 mt-3">
            <h2 className="h6 pb-1 mb-3 color_grey">
              Great! Let’s Narrow This Step Down.
            </h2>
            {/* Required Field: Must choose one. */}
            <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3">
              {/* Image Processing */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="img-processing"
                  name="engineering-category"
                  value="Image Processing"
                  onChange={handleChange}
                  checked={
                    formData["engineering-category"] === "Image Processing"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="img-processing"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/image_process.svg"
                    alt="Image Processing"
                  />
                  <div className="main_card_info">
                    <h3>Image Processing</h3>
                    <p>
                      Detection of Visual Defects and Anomalies, Barcode
                      Reading, Recognition of Product Positions, Mapping.
                    </p>
                  </div>
                </label>
              </div>

              {/* Cloud Computing */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="cloud-data"
                  name="engineering-category"
                  value="Cloud Computing"
                  onChange={handleChange}
                  checked={
                    formData["engineering-category"] === "Cloud Computing"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="cloud-data"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/cloud.svg"
                    alt="Cloud Computing"
                  />
                  <div className="main_card_info">
                    <h3>Cloud Computing</h3>
                    <p>
                      Data Analysis, Data Visualization, Big Data, Data Mining,
                      Data Architecture.
                    </p>
                  </div>
                </label>
              </div>

              {/* DevOps */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="devops"
                  name="engineering-category"
                  value="DevOps"
                  onChange={handleChange}
                  checked={formData["engineering-category"] === "DevOps"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="devops"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/devops.svg"
                    alt="DevOps"
                  />
                  <div className="main_card_info">
                    <h3>DevOps</h3>
                    <p>
                      DevOps Development, Configuration, and Consulting
                      Services, Amazon Web Services (AWS), AWS-for-DevOps.
                    </p>
                  </div>
                </label>
              </div>

              {/* Virtual Reality */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="vr"
                  name="engineering-category"
                  value="Virtual Reality"
                  onChange={handleChange}
                  checked={
                    formData["engineering-category"] === "Virtual Reality"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="vr"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/vr.svg"
                    alt="Virtual Reality"
                  />
                  <div className="main_card_info">
                    <h3>Virtual Reality</h3>
                    <p>
                      Visual Recognition, Face Recognition, Gesture Recognition,
                      Object Recognition, 3D Environment Modeling, Manipulation.
                    </p>
                  </div>
                </label>
              </div>

              {/* Augmented Reality */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="ar"
                  name="engineering-category"
                  value="Augmented Reality"
                  onChange={handleChange}
                  checked={
                    formData["engineering-category"] === "Augmented Reality"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="ar"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/ar.svg"
                    alt="Augmented Reality"
                  />
                  <div className="main_card_info">
                    <h3>Augmented Reality</h3>
                    <p>
                      Effective AR solutions offering interactive digital
                      experiences that enhance real-world scenes.
                    </p>
                  </div>
                </label>
              </div>

              {/* High Technology */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="big-tech"
                  name="engineering-category"
                  value="High Technology"
                  onChange={handleChange}
                  checked={
                    formData["engineering-category"] === "High Technology"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="big-tech"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/board.svg"
                    alt="High Technology"
                  />
                  <div className="main_card_info">
                    <h3>High Technology</h3>
                    <p>
                      Designing and developing next-generation embedded
                      applications for those in advanced technology fields.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EngineeringTypeStep;
